import { defaultTo } from 'lodash';
import { ModelRecord } from '@common/models/Model';
import { VeterinarianModel } from '@common/models/VeterinarianModel';
import { SyncModel, ISyncModel } from '@common/models/SyncModel';

export interface IClinicVeterinarianModel extends ISyncModel {
  clinicVeterinarianId: number;
  veterinarianId: number;
  clinicId: number;
  isClinicVeterinarian: boolean;
  veterinarian: VeterinarianModel;
  clinic: any; // Assuming clinic can be any type
}

export class ClinicVeterinarianModel
  extends SyncModel
  implements ModelRecord<IClinicVeterinarianModel>
{
  clinicVeterinarianId: number;
  veterinarianId: number;
  clinicId: number;
  isClinicVeterinarian: boolean;
  veterinarian: VeterinarianModel;
  clinic: any; // Assuming clinic can be any type

  constructor(params: Partial<IClinicVeterinarianModel>) {
    super(params);
    this.clinicVeterinarianId = defaultTo(params.clinicVeterinarianId, 0);
    this.veterinarianId = defaultTo(params.veterinarianId, 0);
    this.isClinicVeterinarian = defaultTo(params.isClinicVeterinarian, false);
    this.veterinarian = new VeterinarianModel(params.veterinarian);
    this.clinicId = defaultTo(params.clinicId, 0);
  }
}
